<script lang="ts">
import AlertDialog from '@/app/common/components/AlertDialog.vue';
import AttachUploader from '@/app/common/components/AttachUploader.vue';
import { formatDateBE } from '@/app/common/dateFormate';
import { ATTACH_TYPE } from '@/app/const';
import { BaseAlert } from '@/interface/BaseAlert.interface';
import { OpmAttachmentUpload, OpmReportResult } from '@/interface/OpmComplaint.interface';
import { fileService } from '@/services/serviceProvider';
import { ref } from 'vue';

export default {
    components: {
        AlertDialog,
        AttachUploader
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        cancelText: {
            type: String,
            default: 't-cancel'
        },
        attachments: {
            type: Array<Object>,
            default: []
        }
    },
    emits: ['update:modelValue', 'onConfirm', 'onCancel', 'update:attachments'],
    setup() {
        const opmReportResultForm = ref();
        const fileSv = fileService;

        return { opmReportResultForm, fileSv };
    },
    data() {
        return {
            model: {
                allowView: true,
                docType: 'X',
                docTypeText: 'อื่นๆ',
                docTypeId: 8,
                docTypeIdText: 'เอกสารประกอบ',
            } as OpmAttachmentUpload,
            attachTypes: [
                {
                    value: 1,
                    label: 'คำร้อง'
                },
                {
                    value: 2,
                    label: 'ข้อเสนอแนะ'
                },
                {
                    value: 3,
                    label: 'หนังสือรับ-ส่ง'
                },
                {
                    value: 4,
                    label: 'การอนุมัติ-เห็นชอบ'
                },
                {
                    value: 5,
                    label: 'รายงานผลการพิจารณา'
                },
                {
                    value: 6,
                    label: 'ผลการวินิจฉัย'
                },
                {
                    value: 7,
                    label: 'การประชุม'
                },
                {
                    value: 8,
                    label: 'เอกสารประกอบ'
                },
                {
                    value: 9,
                    label: 'รูปภาพ'
                },
            ] as any[],
            attachSubTypes: [
                {
                    value: 'I',
                    label: 'หนังสือรับ'
                },
                {
                    value: 'O',
                    label: 'หนังสือส่ง'
                },
                {
                    value: 'X',
                    label: 'อื่นๆ'
                },
            ],
            successAlert: {
                display: false,
                success: true
            } as BaseAlert,
            failAlert: {
                display: false,
                success: false
            } as BaseAlert,
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
            }
        }
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        },
        headers() {
            return [
                { title: this.$t('t-order'), sortable: false, key: 'index', align: 'center', width: '5%' },
                { title: this.$t('t-file-name'), key: 'fileName' },
                { title: '', key: 'actions', sortable: false, width: '2%' },
            ] as any[];
        },
        isBookReceive() {
            return this.model.docType === 'I';
        },
        isBookSend() {
            return this.model.docType === 'O';
        },
        isOther() {
            return this.model.docType === 'X';
        },
    },
    methods: {
        async confirm() {
            const valid = await this.opmReportResultForm.validate();
            if (valid.valid) {
                await this.doAddFiles();
                // this.$emit('onConfirm', this.request);
            }
        },
        cancel() {
            // this.request.ascEndReason = undefined;
            this.dialogShow = false;
            this.$emit('onCancel')
        },
        async doAddFiles() {
            let _attachs = [] as any[];
            this.model.attachments.forEach(attach => {
                _attachs.push({
                    ...this.model,
                    fileName: attach.name,
                    blob: attach.blob,
                    type: ATTACH_TYPE.NEW
                })
            });
            this.$emit('update:attachments', _attachs);
            this.dialogShow = false;
            this.model.attachments = [];
        },
        allAttachments(): any[] {
            let newUploads = this.model.attachments as any[] ?? [];
            newUploads.forEach(up => { up.type = ATTACH_TYPE.NEW });
            return newUploads;
        },
        checkDuplicateFileName() {
            let fileNameList = [] as string[];
            let allAttach = this.allAttachments();
            let allFilesUser = allAttach.map(o => {
                if (o.type === ATTACH_TYPE.NEW) {
                    return o.name;
                }
            })
            allFilesUser.forEach(fileName => {
                if (fileNameList.includes(fileName)) {
                    this.failAlert = {
                        display: true,
                        messageTitle: this.$t('t-cannot-duplicate-file-name'),
                        messageText: this.$t('t-please-change-file-name'),
                    } as BaseAlert;
                    let index = this.model.attachments?.findIndex(o => o.name === fileName) as number;
                    if (index >= 0) {
                        this.model.attachments?.splice(index, 1);
                    }
                    return;
                } else {
                    fileNameList.push(fileName);
                }
            })
        },
        overSizeLimit() {
            this.failAlert = {
                display: true,
                messageTitle: this.$t('t-cannot-upload-over-size-limit'),
                messageText: this.$t('t-please-select-another-file'),
            } as BaseAlert;
        },
        errorEmptyFile() {
            this.failAlert = {
                display: true,
                messageTitle: this.$t("t-attachment-error-0byte"),
                messageText: this.$t('t-please-select-another-file'),
            } as BaseAlert;
        },
        deleteAttachment(attach: any) {
            let allAttachs = this.allAttachments();
            if (allAttachs && allAttachs.length > 0) {
                if (attach.type === ATTACH_TYPE.NEW) {
                    let newUploads = this.model.attachments;
                    this.model.attachments = newUploads?.filter(o => o.name !== attach.name);
                }
            }
        },
        runCallbackConfirm(item: any) {
            if (item.callBack)
                item.callBack();
        },
        runCallbackCancel(item: any) {
            if (item.callBackCancel)
                item.callBackCancel();
        },
    }
}
</script>
<template>
    <v-dialog v-model="dialogShow" width="50%" :close-on-back="false" persistent>
        <v-form ref="opmReportResultForm" class="admin-form app-form-input" validate-on="submit lazy"
            @submit.prevent="confirm">
            <v-card class="dialog-card app-form-input">
                <v-toolbar density="compact">
                    <v-toolbar-title>{{ $t('t-complaint-opm-file-please-fill-info') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon="mdi-close" @click="cancel"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider class="mx-4"></v-divider>
                <v-card-text style="overflow-y: auto; position: relative; overflow-x: hidden;">
                    <v-row>
                        <v-col cols="12" class="upload-section pt-0" style="min-height: 130px;">
                            <AttachUploader v-model="model.attachments" fileType="attach"
                                @on-upload-success="checkDuplicateFileName" @on-over-size-limit="overSizeLimit"
                                @on-error-empty-file="errorEmptyFile">
                            </AttachUploader>
                        </v-col>
                        <v-col v-if="model.attachments && model.attachments.length > 0" cols="12">
                            <v-data-table :headers="headers" :items="allAttachments()" hide-default-footer
                                :no-data-text="$t('t-no-data-available')" :items-per-page="-1">
                                <template #[`item.index`]="{ index }">
                                    <div class="w-100 text-center">{{ index + 1 }}</div>
                                </template>
                                <template #[`item.fileName`]="{ item }">
                                    <span>{{ item.name }}</span>
                                </template>
                                <template v-slot:item.actions="{ item, index }">
                                    <div class="actions d-flex align-center">
                                        <v-btn variant="text" color="primary" @click="fileSv.viewFileInEditMode(item)">
                                            <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
                                            <span>{{ $t('t-view-doc') }}</span>
                                        </v-btn>
                                        <v-btn variant="text" color="error" @click="deleteAttachment(item)">
                                            <v-icon icon="mdi mdi-close" class="mr-1"></v-icon>
                                            <span>{{ $t('t-delete') }}</span>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col cols="12">
                            <div class="text-label">{{ $t('t-complaint-opm-file-description') }}</div>
                            <v-text-field v-model="model.detail" class="hide-float-label" variant="outlined"
                                hide-details="auto" density="comfortable">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <div class="text-label">{{ $t('t-complaint-request-type') }}</div>
                            <v-row>
                                <v-col cols="7">
                                    <v-select v-model="model.docTypeId" class="hide-float-label" variant="outlined"
                                        :label="$t('t-please-select')" hide-details="auto" :items="attachTypes"
                                        item-value="value" item-title="label" density="comfortable" readonly
                                        :rules="[rules.required(`${$t('t-please-select')}${$t('t-complaint-request-type')}`)]">
                                    </v-select>
                                </v-col>
                                <v-col cols="5">
                                    <v-select v-model="model.docType" class="hide-float-label" variant="outlined"
                                        :label="$t('t-please-select')" hide-details="auto" :items="attachSubTypes"
                                        item-value="value" item-title="label" density="comfortable" readonly
                                        :rules="[rules.required(`${$t('t-please-select')}${$t('t-complaint-request-type')}`)]">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-container class="mx-0">
                        <div class="d-flex justify-end">
                            <v-btn @click="cancel" variant="outlined" color="primary" size="large">
                                {{ $t(cancelText) }}
                            </v-btn>
                            <v-btn @click="doAddFiles" variant="flat" color="primary" size="large">
                                {{ $t('t-complaint-opm-add-file') }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
    <!-- Success -->
    <AlertDialog v-model="successAlert.display" :header="successAlert.header" :title="successAlert.messageTitle"
        :text="successAlert.messageText" :success-icon="successAlert.icon"
        @on-confirm="runCallbackConfirm(successAlert)">
    </AlertDialog>
    <!-- Fail -->
    <AlertDialog v-model="failAlert.display" :header="failAlert.header" :title="failAlert.messageTitle"
        :text="failAlert.messageText" :success="false">
    </AlertDialog>
</template>